module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"Integración para las tiendas de ECommerce.","payText":["Contamos con plugins para las principales plataformas de comercio electrónico."],"payBtn":"MÁS INFORMACIÓN"},"es":{"payTitulo":"Integración para las tiendas de ECommerce.","payText":["Contamos con plugins para las principales plataformas de comercio electrónico."],"payBtn":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
